import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'apmLocations',
    collectionActionName: 'APM_LOCATIONS',
    itemActionName: 'APM_LOCATION',
});
